import styled from 'styled-components';

import background from '../images/background.jpg';

export const Wrapper = styled.div`
  @media (max-width: 960px) {
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-left: 1.188rem;
    padding-right: 1.313rem;
    padding-bottom: 1.188rem;
  }

  display: flex;
  flex-direction: row;
  text-align: center;
  min-height: 100vh;
  width: 100%;

  .leftSide {
    @media (max-width: 960px) {
      flex-basis: 100%;
      box-shadow: none;
      width: 100%;
    }
    flex-basis: 40%;
    text-align: center;
    background: var(--color-surface);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-shadow: 5px 0 100px var(--color-shadow);
    position: relative;
    max-width: 580px;
  }
  .rightSide {
    @media (max-width: 960px) {
      display: none;
    }
    background: center / cover no-repeat url(${background});
    flex-basis: 60%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    @media (min-width: 1500px) {
      flex-basis: 100%;
    }
    .autoscript-one {
      margin-bottom: 30px;
      img {
        width: 520px;
      }
    }
  }
  .poweredBy {
    width: 400px;
    font-weight: 500;
    font-size: 22px;
    line-height: 28px;
    color: var(--color-text-muted);
    margin-bottom: 35px;
    text-align: left;
    letter-spacing: 0.02em;
    margin-top: -10px;
    & a {
      text-decoration: underline;
      &:hover {
        text-decoration: none;
      }
    }
  }
  .convertZoom {
    font-weight: 500;
    font-size: 22px;
    line-height: 32px;
    text-align: center;
    color: var(--color-logo);
    max-width: 440px;
  }
  .link {
    color: currentColor;
    text-decoration: none;
  }
  .leftSideFooter {
    position: absolute;
    bottom: 50px;

    font-weight: 400;
    font-size: 16px;
    line-height: 21px;
    letter-spacing: 0.02em;
    color: var(--color-title);
  }

  html[data-theme='dark'] & .leftSide {
    background: var(--color-surface);
    box-shadow: 5px 0 60px var(--color-shadow);
  }

  html[data-theme='dark'] & .rightSide {
    position: relative;
  }

  html[data-theme='dark'] & .rightSide::after {
    content: '';
    position: absolute;
    inset: 0;
    background: var(--color-overlay);
  }

  html[data-theme='dark'] & .rightSide > * {
    position: relative;
    z-index: 1;
  }

  html[data-theme='dark'] & .poweredBy {
    color: var(--color-text-subtle);
  }

  html[data-theme='dark'] & .convertZoom {
    color: var(--color-text);
  }

  html[data-theme='dark'] & .leftSideFooter {
    color: var(--color-text-muted);
  }
  @media (max-width: 960px) {
    .leftSide {
      flex-basis: auto;
      min-width: 0;
    }
    .leftSideFooter {
      position: static;
      margin-top: 24px;
      padding-bottom: 16px;
    }
  }
`;
